import {connect} from "react-redux";
import * as CoursesActions from '../../../store/actions/coursesActions';
import SortableCourses from '../../../components/AdminPanel/Strategy/SortableCourses';

const mapStateToProps = (state) => ({
    ...state.courses
});

const mapDispatchToProps = (dispatch) => ({
    handleChangeVisible: (id, token) => {
        dispatch(CoursesActions.handleVisibleChange(id, token));
    },
    removeAssignedTest: (id, token) => {
        dispatch(CoursesActions.deleteAssignedTest(id, token));
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SortableCourses);


// WEBPACK FOOTER //
// ./src/containers/AdminPanel/Strategy/SortableCoursesContainer.js